import Vue from 'vue'

import VueComponentStyle from 'vue-component-style';

Vue.use(VueComponentStyle);